module.exports = __webpack_public_path__ + "static/img/banner07.b6a297c9.png";